import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login/login.component';
import { ApplicationUsersListComponent } from './core/components/application-users/application-users-list/application-users-list.component';
import { AuthGuard } from './core/auth.gaurd';
import { ApplicationUsersDetailComponent } from './core/components/application-users/application-users-detail/application-users-detail.component';
import { SdsSearchComponent } from './core/components/sds-search/sds-search.component';
import { AdminGuard } from './core/admin.gaurd';
import { LoginReportsComponent } from './core/components/activity-reports/login-reports/login-reports.component';
import { DownloadReportsComponent } from './core/components/activity-reports/download-reports/download-reports.component';
import { SearchSdsReportsComponent } from './core/components/activity-reports/search-sds-reports/search-sds-reports.component';

const routes:
Routes = [  { path: '', redirectTo: '/search', pathMatch: 'full' },
{ path: 'search', component: SdsSearchComponent ,canActivate: [AuthGuard]},

  { path: 'login', component: LoginComponent },
  { path: 'application-user-list', component: ApplicationUsersListComponent, canActivate: [AuthGuard,AdminGuard]},
  { path: 'application-user-new', component: ApplicationUsersDetailComponent  ,canActivate: [AuthGuard,AdminGuard]},
  { path: 'application-user-detail', component: ApplicationUsersDetailComponent  ,canActivate: [AuthGuard,AdminGuard]},
  { path: 'login-report', component: LoginReportsComponent  ,canActivate: [AuthGuard,AdminGuard]},
  { path: 'download-report', component: DownloadReportsComponent  ,canActivate: [AuthGuard,AdminGuard]},
  { path: 'search-sds-report', component: SearchSdsReportsComponent  ,canActivate: [AuthGuard,AdminGuard]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
